import { HelperBotType, HelperBotTypeLabels, RankType } from "./enum/enum";

export const HELPER_BOT_BULLET_PRICE = 2300;

export const HelperBots = [
  {
    id: 0,
    imageUrl: "/assets/imgs/helper/1.png",
    name: HelperBotTypeLabels[HelperBotType.CrimeBot],
    description:
      "A stealthy robot with cloaking tech, swift movements, and adaptive weapons, executing street crimes like theft and vandalism with precision, evading authorities",
    rank: "Low" as RankType,
    timeRemaining: "15 minutes",
    credits: 1,
    isStarted: false,
    min: 10,
    max: 2000,
    helperBotCount: [10, 20, 50, 100, 150, 200, 300, 500, 1000, 2000],
    attemptDuration: 15, // 15 minutes
    cashReward: true,
  },
  {
    id: 1,
    imageUrl: "/assets/imgs/helper/2.png",
    name: HelperBotTypeLabels[HelperBotType.GrandTheftAutoBot],
    description:
      "A sleek robot with advanced hacking tools, silent hydraulics, and infrared sensors, effortlessly bypassing security systems to steal cars with precision and speed.",
    rank: "Medium" as RankType,
    credits: 4,
    isStarted: false,
    min: 40, // This is rounded value, original min value from contract is 45
    max: 464, // This is rounded value, original max value from contract is 350
    helperBotCount: [40, 100, 200, 400, 464],
    attemptDuration: 30, // 30 minutes
    cashReward: true,
  },

  {
    id: 3,
    imageUrl: "/assets/imgs/helper/3.jpg",
    name: HelperBotTypeLabels[HelperBotType.BoozeSmugglingBot],
    description:
      "A robot with hidden compartments, adaptive routes, and encrypted communications, efficiently smuggling booze past authorities, maximizing profits through stealth and strategic black-market deals.",
    rank: "High" as RankType,
    credits: 7,
    isStarted: false,
    min: 210, // This is rounded value, original min value from contract is 200
    max: 1498, // This is rounded value, original max value from contract is 1500
    helperBotCount: [210, 280, 350, 700, 1050, 1400, 1498],
    attemptDuration: 120, // 120 minutes
    cashReward: true,
  },
  {
    id: 4,
    imageUrl: "/assets/imgs/helper/4.jpg",
    name: HelperBotTypeLabels[HelperBotType.NarcoticsSmugglingBot],
    description:
      "A robot with hidden compartments, adaptive routes, and encrypted communications, efficiently smuggling narcotics past authorities, maximizing profits through stealth and strategic black-market deals.",
    rank: "High" as RankType,
    credits: 10,
    isStarted: false,
    min: 350,
    max: 1500,
    helperBotCount: [350, 400, 450, 500, 750, 1000, 1500],
    attemptDuration: 180, // 180 minutes
    cashReward: true,
  },

  {
    id: 2,
    imageUrl: "/assets/imgs/helper/5.png",
    name: HelperBotTypeLabels[HelperBotType.ShootingPracticeBot],
    description:
      "Introducing TargetTrainer, a robot diligently honing its aiming skills by shooting bottles in its backyard, utilizing advanced algorithms to improve accuracy and reaction time efficiently.",
    rank: "Medium" as RankType,
    credits: 8,
    isStarted: false,
    min: 400, // This is rounded value, original min value from contract is 500
    max: 1000,
    helperBotCount: [400, 600, 800, 1000],
    attemptDuration: 45, // 45 minutes
    cashReward: false,
  },

  {
    id: 5,
    imageUrl: "/assets/imgs/helper/6.png",
    name: HelperBotTypeLabels[HelperBotType.BulletDealerBot],
    description:
      "An automatic bot swiftly compares prices, checks legality, and assists users in purchasing bullets efficiently, ensuring compliance with local regulations and preferences.",
    rank: "Medium" as RankType,
    credits: 12,
    isStarted: false,
    min: 48, // This is rounded value, original min value from contract is 500
    max: 1992,
    helperBotCount: [48, 60, 120, 240, 480, 720, 1440, 1992],
    attemptDuration: 120, // 120 minutes
    cashReward: false,
    bulletReward: true,
  },
];
